<script type="text/ecmascript-6">
    export default {
        props: {
            items: Array,
            displayName: String,
        },

        data() {
            return {
                baseUrl: Scoop.baseUrl,
                token: Scoop.csrfToken,
            }
        },

        methods: {
            statusText(displayName, count) {
                return __('uploadFilter.' + displayName, {'count': count});
            },
            itemText(item, key) {
                if (key < 4) {
                    return item;
                }

                if (key === 5) {
                    return '...';
                }

                return '';
            },
        },

        mounted() {
            $('.collapse-link-discontinued-articles').on('click', function (e) {
                e.preventDefault();
                var ibox = $(this).closest('div.ibox');
                var button = $(this).find('i');
                var content = ibox.children('.ibox-content');
                content.slideToggle(200);
                button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                setTimeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            });
        },
    }
</script>
<template>
    <div class="ibox collapsed">
        <div class="ibox-title panel-warning">
            <h5>
                <i class="fa fa-info-circle m-r-xs text-warning"></i>
                <span v-text="statusText(displayName, items.length)"></span>
            </h5>
            <div class="ibox-tools">
                <a class="collapse-link-discontinued-articles"><i class="fa fa-chevron-up"></i></a>
            </div>
        </div>
        <div class="ibox-content">
            <ul class="unstyled">
                <template v-for="(item, key) in items" v-if="itemText(item, key)">
                    <li v-text="itemText(item, key)"></li>
                </template>
            </ul>
            <form :action="baseUrl + '/scoop/downloadReport'" method="post" :name="displayName"
                  enctype="multipart/form-data">
                <input type="hidden" name="_token" :value="token"/>
                <input type="hidden" name="data" :value="items"/>
                <input type="hidden" name="displayName" :value="displayName"/>
                <button type="submit" class="btn btn-white">
                    <i class="fa fa-download"></i>
                    <span v-text="__('scoop-os.uploadFilter.btn_Export')"></span>
                </button>
            </form>
        </div>
    </div>
</template>